<template>
  <div class="ecm__navbar">
    <TopNavbar />
    <!-- <BottomNavbar /> -->
  </div>
</template>

<script>
import TopNavbar from '@/components/Navbar/TopNavbar.vue'
import BottomNavbar from '@/components/Navbar/BottomNavbar.vue'

export default {
  name: 'Navbar',
  components: {
    TopNavbar,
    BottomNavbar
  }
}
</script>

<style lang="scss" scoped>
</style>
